<script setup lang="ts">
import DropdownItem from '#components/elements/dropdown/DropdownItem.vue';
import DropdownMenu from '#components/elements/dropdown/DropdownMenu.vue';
import { useLanguage } from '#composables/useLanguage';
import type { UserType } from '#domain/core/user/user.query';
import { useAuthStore } from '#stores/auth.store';
import { computed, type ComputedRef, type PropType } from 'vue';
import VueFeather from 'vue-feather';
import type { RouteLocationRaw } from 'vue-router';
import type { IconName } from '../../icons/icon.model';

const { t } = useLanguage();

defineProps({
  user: { type: Object as PropType<UserType>, required: true }
});
const authStore = useAuthStore();

interface UserNavigationType {
  name: string;
  icon?: IconName;
  onclick?: () => void;
  link?: RouteLocationRaw;
}
const userNavigation: ComputedRef<UserNavigationType[]> = computed(() => [
  {
    name: t('userSettings.title'),
    icon: 'settings',
    link: { name: 'settings' }
  },
  {
    name: t('userSettings.logout.button'),
    icon: 'log-out',
    onclick: () => {
      authStore.logout();
    }
  }
]);
</script>
<template>
  <DropdownMenu as="div" position="left">
    <img v-if="user.avatarUrl" class="h-8 w-8 rounded-full bg-gray-50" :src="user.avatarUrl" alt="" />
    <VueFeather
      v-if="!user.avatarUrl"
      size="20"
      stroke-width="2"
      type="user"
      class="rounded-full bg-gray-50"
      aria-hidden="true"
    />

    <span class="hidden lg:flex lg:items-center">
      <span class="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">{{ user.displayName }} </span>
    </span>
    <template #items>
      <DropdownItem
        v-for="item in userNavigation"
        :key="item.name"
        v-slot="{ active }"
        :icon="item.icon"
        :link="item.link"
        @click="item.onclick"
      >
        <span :class="[active ? 'bg-gray-50' : '', 'text-sm leading-6 text-gray-900']">
          {{ item.name }}
        </span>
      </DropdownItem></template
    >
  </DropdownMenu>
</template>
